export enum CommentPlacementLocation {
  beforeDocument = "beforeDocument",
  beforeTitle = "beforeTitle",
  beforeConclusion = "beforeConclusion",
}

export const CommentPlacementLocations = [
  {
    value: CommentPlacementLocation.beforeDocument,
    label: "Before Document",
  },
  {
    value: CommentPlacementLocation.beforeTitle,
    label: "Before Title",
  },
  {
    value: CommentPlacementLocation.beforeConclusion,
    label: "Before Conclusion",
  },
];
